<script>
  export default {
    name: "WidgetImageGalleryWithText",
    props: {
      /** The widgets title */
      title: {
        type: String,
        required: true
      },
      /** Callout text included in the widget */
      text: {
        type: String,
        default: null
      },
      /** An array of image objects which include "small", "large" image URLs */
      images: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      gallery() {
        const gallery = [];
        this.images.forEach((image) => {
          gallery.push({
            src: image.large,
            thumbnail: image.small,
          });
        })
        return gallery;
      }
    }
  }
</script>

<template>
  <div class="widget-wrapper">
    <div class="callout--gallery-with-text">
      <h3 class="callout__title">{{ title }}</h3>
      <p v-if="text" class="callout__summary">{{ text }}</p>
      <div v-if="gallery" class="gallery-wrapper">
        <silent-box :gallery="gallery"></silent-box>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .gallery-wrapper {
    margin-top: 10px;
  }
</style>